import React from 'react';
import { useMediaQuery } from 'react-responsive';
import STPLoader from 'images/STPloader.gif';

interface SelectProps extends React.HTMLAttributes<HTMLSelectElement>{
    name: string,
    disabled?: boolean,
    defaultValue?: string,
    onChange: any,
    isFetchingData: boolean,
    className?: string,
    childOptions: any,
    selectRef: any,
    HTMLProps?: React.HTMLAttributes<HTMLSelectElement>
}

const LoaderSelect: React.FC<SelectProps> = ({ name, disabled, onChange, isFetchingData, childOptions, defaultValue, className,selectRef, ...rest }: SelectProps) => {
    const isMobile = useMediaQuery({ maxWidth: 767 });

    return (
        <div className='posR'>
            {isFetchingData && <div className=" stpLoader">
                <div className='stploaderText'>
                    <p>Fetching details</p>
                    <img src={STPLoader} alt="landing-page-loader" />
                </div>
            </div>}
            <select
                required
                name={name}
                disabled={disabled}
                defaultValue={defaultValue}
                onChange={(event)=>onChange(event)}
                ref={selectRef}
                {...rest}
            >
                    {childOptions}
            </select>
        </div>
    );
}

export default LoaderSelect;